import { socialLinkLabel, socialLinkUrl, type SocialLink } from '@hue/contracts';

export function SocialLinks({
  links = [],
  label,
}: {
  links?: SocialLink[] | undefined;
  label: string;
}) {
  if (!links.length) return null;
  return (
    <div role="group" aria-label={label} className="mt-4 flex min-w-0 flex-wrap gap-x-5 gap-y-2">
      {links.map((link, index) => {
        const url = socialLinkUrl(link);
        const text = `${socialLinkLabel(link)} · @${link.handle}`;
        return url ? (
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${text} (abre em nova aba)`}
            className="break-all text-sm font-semibold text-content underline underline-offset-4"
          >
            {text}
          </a>
        ) : (
          <span key={index} className="break-all text-sm text-content-secondary">
            {text}
          </span>
        );
      })}
    </div>
  );
}
